import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useAppCardsDocumentDetails } from "./appcard.hook";

const AddEditAppCard = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useAppCardsDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      cardNameEn: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardNameEn)
        : decodeHTML(editSubCategories?.cardNameEn),
      cardNameMs: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardNameMs)
        : decodeHTML(editSubCategories?.cardNameMs),
      cardNameZh: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardNameZh)
        : decodeHTML(editSubCategories?.cardNameZh),
      cardDescEn: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardDescEn)
        : decodeHTML(editSubCategories?.cardDescEn),
      cardDescMs: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardDescMs)
        : decodeHTML(editSubCategories?.cardDescMs),
      cardDescZh: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.cardDescZh)
        : decodeHTML(editSubCategories?.cardDescZh),

      published: editSubCategoriesById?.payload
        ? editSubCategoriesById?.payload?.published
        : editSubCategories?.published,
    },
    fields: fields.appCardsListContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["fbImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Mobile App",
      subModule: "appCardsListContent",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        airport: currentAirport,
      },
      status: status,
    };

    console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Mobile Card`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/get-mobile-app-cards/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/create-mobile-app-cards`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Mobile App"
      />
    </ContentWrapper>
  );
};

export default AddEditAppCard;
